import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./index.less";
import copy from "../../../../assets/copy.png";
import finger from "../../../../assets/finger.png";
import { Toast, Button } from "antd-mobile";
import Tooltip from "components/Tooltip";
import { useInView } from 'react-intersection-observer';

interface ListProps {
  title: string;
  subtitle: string;
  isLast: boolean;
  id: string;
}
const Index: React.FC<ListProps> = (props: ListProps) => {
  const { title, subtitle, isLast, id } = props;
  console.log(id, "___id,99999");
  const selectableStyle: React.CSSProperties = {
    userSelect: "text",
    WebkitUserSelect: "text",
    MozUserSelect: "text",
    msUserSelect: "text",
  };
  const handleCopy = useCallback(async () => {
    console.log(subtitle);
    if (navigator.clipboard && window.isSecureContext) {
      try {
        Toast.show({
          icon: "success",
          content: "Việc nhân rộng thành công",
        });
      } catch (err) {
        Toast.show({
          icon: "fail",
          content: "Sao chép không thành công",
        });
      }

      // 对于现代浏览器和安全上下文
      return navigator.clipboard.writeText(subtitle);
    } else {
      // 回退到旧方法
      const textArea = document.createElement("textarea");
      textArea.value = subtitle;
      textArea.style.position = "fixed"; // 避免滚动到底部
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        Toast.show({
          icon: "success",
          content: "Việc nhân rộng thành công",
        });
        return document.execCommand("copy");
      } catch (err) {
        Toast.show({
          icon: "fail",
          content: "Sao chép không thành công",
        });
        console.error("Failed to copy: ", err);
      } finally {
        document.body.removeChild(textArea);
      }
    }
  }, [subtitle]);
  console.log('subtitle', subtitle)


    // #region 提示
    const [tooltipState, setTooltipState] = useState<boolean | undefined>();
    const showFlag = useRef(false);
    const { ref, inView } = useInView({ threshold: 0.2 });
    useEffect(() => {
      let timer: any;
      if (inView && !showFlag.current) {
        showFlag.current = true;
        setTooltipState(true);
        timer = setTimeout(() => {
          setTooltipState(false);
        }, 5000);
      } else {
        setTooltipState(undefined);
      }
  
      return () => {
        if(timer) {
          clearTimeout(timer);
        }
      }
    }, [inView]);
    // #endregion


  return (
    <>
      {id === "33333" || id === "22222555" ? (
        subtitle ? (
          <div className={styles.desc}>
            <span className={styles.nameFront} style={selectableStyle}>
              {title}{" "}
            </span>{" "}
            <div className={styles.nameLast}>
              <span>{subtitle}</span>
              {isLast ? (
                <div style={{ position: 'relative' }}>
                  <Tooltip
                    content="Không quét mã được? Sử dụng sao chép-dán. Đừng nhập thủ công, tránh lỗi!"
                    open={tooltipState}
                    arrowPlacement="end"
                  >
                    <button
                      className={styles.copy}
                      ref={ref}
                      onClick={() => {
                        handleCopy();
                      }}
                    >
                      Sao chép
                    </button>
                  </Tooltip>

                  <img style={{ position: 'absolute', right: 0, top: "25px", width: '33px', height: '33px' }} src={finger} alt="finger" />
                </div>

              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          ""
        )
      ) : (
        id === "22222" && !subtitle ? '' : (
          <div className={styles.desc}>
            <span className={styles.nameFront} style={selectableStyle}>
              {title}{" "}
            </span>{" "}
            <div className={styles.nameLast}>
              <span>{subtitle}</span>
              {isLast ? (
                <a href="#" className={styles.clickbleArea}>
                  <img
                    onClick={() => {
                      handleCopy();
                    }}
                    className={styles.copy}
                    src={copy}
                    alt=""
                  />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        )
      )}
    </>
  );
};
export default Index;
